import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface FAQProps {
   deleteAccountRef: React.RefObject<HTMLHeadingElement>;
   dataRightsRef: React.RefObject<HTMLHeadingElement>;
}

const FAQ: React.FC<FAQProps> = ({ deleteAccountRef, dataRightsRef }) => {
   const { t } = useTranslation();

   return (
      <Container className='pt-3 pb-3'>
         <Row>
            <Col>
               <h2 className='faq-title'>{t("faq.title")}</h2>
               <p className='faq-description'>{t("faq.description")}</p>
               <h3 id='delete-account' ref={deleteAccountRef}>
                  {t("faq.deleteAccount.title")}
               </h3>
               <ol>
                  <li>
                     <span
                        dangerouslySetInnerHTML={{
                           __html: t("faq.deleteAccount.step1"),
                        }}
                     />
                  </li>
                  <li>{t("faq.deleteAccount.step2")}</li>
               </ol>

               <h3 id='data-rights' ref={dataRightsRef}>
                  {t("faq.dataPrivacy.title")}
               </h3>
               <p
                  dangerouslySetInnerHTML={{
                     __html: t("faq.dataPrivacy.description"),
                  }}
               />
               <a
                  href='/privacy_policy_v2_en.html'
                  target='_blank'
                  className='btn privacy-button'
               >
                  {t("faq.dataPrivacy.viewOnline")}
               </a>
               <a
                  href='/terms_of_use_en.html'
                  target='_blank'
                  className='btn privacy-button ms-2'
               >
                  {t("faq.terms.viewOnline")}
               </a>
            </Col>
         </Row>
      </Container>
   );
};

export default FAQ;
